<template>
    <div>
        <b-row>
            <b-col class="workspace-header">
            </b-col>

            <b-col class="workspace-header">
                <h1 class="text-right">My Settings</h1>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <b-form>
                        <b-form-group
                            label="Printers"
                            label-cols-lg="2"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-group label="(4x2 Thermal) - Fulfillment: Order and Address">
                                <b-input-group>
                                    <b-form-input v-model="settingsForm.printer.barcodePrinter"></b-form-input>

                                    <b-button @click="calibratePrinter(settingsForm.printer.barcodePrinter)">Calibrate
                                    </b-button>
                                </b-input-group>
                            </b-form-group>

                            <b-form-group label="(3x2 Thermal) - Inventory: Item and Bags">
                                <b-input-group>
                                    <b-form-input v-model="settingsForm.printer.zebraPrinter"></b-form-input>

                                    <b-button @click="calibratePrinter(settingsForm.printer.zebraPrinter)">Calibrate</b-button>
                                </b-input-group>
                            </b-form-group>

                            <b-form-group label="(8.5 x 11 Laser) - Fulfillment">
                                <b-input-group>
                                    <b-form-input v-model="settingsForm.printer.letterPrinter"></b-form-input>

                                    <b-button @click="calibratePrinter(settingsForm.printer.letterPrinter)">Calibrate</b-button>
                                </b-input-group>
                            </b-form-group>

                            <b-form-group label="(4x6 Thermal) - Fulfillment">
                                <b-input-group>
                                    <b-form-input v-model="settingsForm.printer.fedexPrinter"></b-form-input>

                                    <b-button @click="calibratePrinter(settingsForm.printer.fedexPrinter)">Calibrate</b-button>
                                </b-input-group>
                            </b-form-group>

                            <b-form-group label="(4x6 Thermal) - Returns">
                                <b-input-group>
                                    <b-form-input v-model="settingsForm.printer.uspsPrinter"></b-form-input>

                                    <b-button @click="calibratePrinter(settingsForm.printer.uspsPrinter)">Calibrate</b-button>
                                </b-input-group>
                            </b-form-group>
                        </b-form-group>

                        <b-form-group
                            label="Scale"
                            label-cols-lg="2"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-group label="Scale Source">
                                <b-form-select v-model="settingsForm.scaleSource" :options="scaleSources"></b-form-select>
                            </b-form-group>

                            <b-form-group v-if="settingsForm.scaleSource === 'qztray'" label="Connection">
                                <b-input-group>
                                    <b-input-group-text>Serial Port</b-input-group-text>
                                    <b-form-input v-model="settingsForm.scalePort"></b-form-input>

                                    <b-input-group-text>Baud</b-input-group-text>
                                    <b-form-input v-model="settingsForm.scaleBaud"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <!--                            <b-form-group>-->
                            <!--                                <b-input-group>-->
                            <!--                                    <b-button @click="testScaleConnection">Test</b-button>-->
                            <!--                                    <b-form-input v-model="scaleWeight" readonly></b-form-input>-->
                            <!--                                </b-input-group>-->
                            <!--                            </b-form-group>-->
                        </b-form-group>

                        <b-form-group
                            label="Camera"
                            label-cols-lg="2"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-group label="Overhead Camera">
                                <b-form-select v-model="settingsForm.overheadCamera" :options="cameraSources"></b-form-select>
                            </b-form-group>

                            <b-form-group label="Scale Camera">
                                <b-form-select v-model="settingsForm.scaleCamera" :options="cameraSources"></b-form-select>
                            </b-form-group>
                        </b-form-group>

                        <b-form-group
                            label="Default Fulfillment Center"
                            label-cols-lg="2"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-group label="Fulfillment Center Location">
                                <b-form-select v-model="settingsForm.fulfillmentCenter" :options="fulfillmentCenters"></b-form-select>
                            </b-form-group>
                        </b-form-group>

                        <b-button variant="primary" @click="save" :disabled="saving">
                            <i class="fa-regular fa-spin fa-spinner fa-fw" v-if="saving"></i>
                            Save Changes
                        </b-button>
                        <i class="fa-solid fa-check fa-fw changing text-success ml-2" v-if="saved"></i>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import printerConfig from '../../plugins/qztray/config/printer';
import {isEqual} from 'lodash';

export default {
    name: 'profile-settings',
    data() {
        return {
            saving: false,
            saved: false,
            scaleSources: [
                {value: null, text: 'Select scale source...', disabled: true},
                {value: 'qztray', text: 'QZTray Serial'},
                {value: 'mock', text: 'Mock Service (randomly returns 5-6 dwt)'},
            ],
            fulfillmentCenters: [
                {value: null, text: 'Global'},
                {value: 'florida', text: 'Florida'},
                {value: 'kansas', text: 'Kansas'},
            ],
            cameraSources: [],
            settingsForm: {
                printer: {},
                scaleSource: null,
                fulfillmentCenter: null,
            },
        };
    },
    created() {
        let settings = JSON.parse(localStorage.getItem('settings')) || false;

        this.settingsForm.printer = settings.printer || printerConfig;
        this.settingsForm.scaleSource = settings.scaleSource || '';
        this.settingsForm.scalePort = settings.scalePort || '';
        this.settingsForm.overheadCamera = settings.overheadCamera || null;
        this.settingsForm.scaleCamera = settings.scaleCamera || null;
        this.settingsForm.fulfillmentCenter = settings.fulfillmentCenter || null;

        this.$qz.connect();

        this.getMedia();
    },
    beforeDestroy() {
        this.$qz.disconnect();
    },
    methods: {
        async getMedia() {
            navigator.mediaDevices.getUserMedia({video: {width: 2048}})
                .then(() => {
                    navigator.mediaDevices.enumerateDevices()
                        .then(devices => {
                            devices.forEach(device => {
                                if (device.kind === 'videoinput') {
                                    this.cameraSources.push({
                                        value: device.deviceId,
                                        text: device.label,
                                    });
                                }
                            });
                        })
                        .catch(function (err) {
                            console.log(err.name + ': ' + err.message);
                        });
                });
        },
        save() {
            this.saving = true;
            localStorage.setItem('settings', JSON.stringify(this.settingsForm));
            // Interactivity for user since saving to localStorage is instantaneous.
            setTimeout(() => {
                this.saving = false;
                this.changed = false;
                this.saved = true;
            }, 300);
            // Unset saved indicator
            setTimeout(() => {
                this.saved = false;
            }, 3000);
        },
        calibratePrinter(printer) {
            let vm = this;

            let data = '\nxa\n';

            vm.$printer.printRaw(printer, data);
        },
    },
};
</script>

<style scoped>
@keyframes colorchange {
    0% {
        opacity: 1
    }
    75% {
        opacity: 1
    }
    100% {
        opacity: 0
    }
}

.changing {
    animation: colorchange ease-out 2s normal forwards;
}
</style>
